<template>
  <div class="dynamic-textarea">
    <textarea @input="change" @compositionstart="onCompositionStart" @compositionend="onCompositionEnd" ref="textarea" :maxlength="maxlength" :placeholder="placeholder" :value="value"></textarea>
    <p ref="shadow">{{value}}</p>
  </div>
</template>
<style lang="stylus" scoped>
@import "../styles/variable.styl";
  .dynamic-textarea {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    line-height: 0;

    textarea, p {
      width: 100%;
      outline: none;
      border: none;
      box-sizing: border-box;
      display: inline-block;
      font-size: $ucar_font_h4;
      text-align: right;
      line-height: 1.6;
      background-color: transparent;
      padding: 24px 40px 24px 20px;
    }

    textarea {
      resize: none;
      height: 100px;
    }

    p {
      position: absolute;
      top: 0;
      left: 0;
      height: auto;
      min-height: 100px;
      visibility: hidden;
      pointer-events: none;
      word-break: break-all;
      word-wrap: break-word;
    }
  }
</style>
<script>
export default {
  data () {
    return {
      flag: true
    }
  },
  props: {
    forbidZh: {
      type: Boolean,
      default: false
    },
    onlyZh:{
      type:Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    handleInput:{
      type:Function
    }
  },
  watch: {
    value (val) {
      setTimeout(() => {
        const { height } = this.$refs.shadow.getBoundingClientRect()
        this.$refs.textarea.style.height = `${height}px`
      })
    }
  },
  methods: {
    onCompositionStart () {
      this.flag = false // 已开启模拟输入（中文输入）
    },
    onCompositionEnd () {
      this.flag = true // 中文输入已结束
    },
    change (event) {
      setTimeout(() => {
        console.log(this.forbidZh, this.onlyZh)
        const { target } = event
        if (this.flag && this.forbidZh) target.value = target.value.replace(/[^A-Za-z\d]/g, '')
        if(this.flag && !this.forbidZh && this.onlyZh) target.value = target.value.replace(/[^\u4E00-\u9FA5]/g,'')
        if (this.flag) {
          this.$emit('input', target.value)
          this.handleInput && this.handleInput(target.value)
        }
      }, 100)
    }
  },
  mounted () {
    setTimeout(() => {
      const { height } = this.$refs.shadow.getBoundingClientRect()
      this.$refs.textarea.style.height = `${height}px`
    })
  }
}
</script>
